/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useEffect,
  useLayoutEffect,
  createContext,
  ReactElement,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';
import updateReadOnlyText from 'services/updateReadOnlyText';

interface ResultsPageContentProps {
  children: ReactElement[] | ReactElement | string | null;
}

interface ResultsPageContext {
  passed: boolean;
}

const ResultsPageContext = createContext<ResultsPageContext | undefined>(
  undefined
);

const ResultsPageContent = (props: ResultsPageContentProps) => {
  const interactionContext = useContext(_interactionContext);
  const { displayPassFailContent, score, passed } = interactionContext;
  const { children } = props;

  const passFailContent = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.dev()) {
      return;
    }

    const checkingSectionHeight = setInterval(() => {
      const section = document.querySelector(
        `#i${interactionContext.id}`
      ) as HTMLElement;

      if (!section) {
        return;
      }
      //
      const height = section.offsetHeight;
      if (height) {
        // console.log('updateReadOnlyText !!!', section);
        //
        // sometimes the content here will not updateReadOnlyText on initial render
        // this is to give it another nudge when it renders at its display height

        updateReadOnlyText(section);
        clearInterval(checkingSectionHeight);
      }
    }, 1000 / 12);

    return () => {
      clearInterval(checkingSectionHeight);
    };
  }, []);

  return (
    <div
      ref={passFailContent}
      css={css`
        width: 100%;
      `}
    >
      {window.dev()
        ? children![displayPassFailContent === 'passed' ? 0 : 1]
        : children![passed ? 0 : 1]}
    </div>
  );
};

export default ResultsPageContent;
export { ResultsPageContext };
